<template>
  <div id="join">
    <div class="search">
      <el-input placeholder="请输入查找的菜单名" clearable prefix-icon="el-icon-search" v-model.trim="formMore.label"></el-input>
      <el-select ref="choose" clearable v-model.trim="more" placeholder="更多筛选" @focus="moreSelect()">
      </el-select>
      <el-button type="warning" @click="search1()" size="mini">搜索</el-button>
      <el-button type="primary" plain size="small"  icon="el-icon-plus" @click="addClick()" v-if="menuManagementAdd">新增</el-button>
      <!-- <el-button @click="resFuntion">重置</el-button> -->
    </div>
    <el-table :data="tableData" row-key="id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      style="width: 100%;padding-left:20px;">
   
      <el-table-column prop="label" label="菜单名称" sortable width="240">
        <!-- <template slot-scope="scope">
        {{scope.row.label}}
       
        </template> -->
      </el-table-column>
      <el-table-column prop="menuLevel" label="菜单级别">
        <template slot-scope="scope">
        <div v-if="scope.row.menuLevel === 0">{{ '一级菜单' }}</div>
        <div v-if="scope.row.menuLevel === 1">{{ '二级菜单' }}</div>
        <div v-if="scope.row.menuLevel === 2">{{ '三级菜单' }}</div>
        <div v-if="scope.row.menuLevel === 3">{{ '四级菜单' }}</div>
        <div v-if="scope.row.menuLevel === 4">{{ '五级菜单' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="controller" label="控制器名称"  width="240">
      </el-table-column>
      <el-table-column prop="action" label="动作名称"  width="240">
      </el-table-column>
      <el-table-column prop="type" label="权限控制"  width="240">
      </el-table-column>
      <el-table-column label="功能" fixed="right" width="160">
        <template slot-scope="scope"  >
          <el-button type="success" plain size="small" @click="editClick(scope.row)" v-if="menuManagementUpdate">编辑</el-button>
          <el-popconfirm title="是否确定删除？" 
            @confirm="changeStatus(scope.row)" style="margin-left: 10px">
            <el-button type="warning" plain size="small" slot="reference" v-if="menuManagementDelete">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加或修改菜单对话框 -->
    <el-dialog :title="AddTitle?'新增菜单':'修改菜单'" :visible.sync="dialogAddVisible" width="720px" append-to-body  @closed="closeForm()">
      <el-form ref="addRuleForm" :model="addForm" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="上级菜单" prop="pid">
              <el-cascader v-model="addForm.pid" :props="{ checkStrictly: true }" :options="menuList"
                @change="handleChange" clearable></el-cascader>
            </el-form-item>
          </el-col>


          <el-col :span="12">
            <el-form-item label="菜单名称" prop="label">
              <el-input v-model="addForm.label" placeholder="请输入菜单名称" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item prop="path">
              <span slot="label">
                路由地址
              </span>
              <el-input v-model="addForm.path" placeholder="请输入路由地址" />
            </el-form-item>
          </el-col> -->

        </el-row>
       
        <el-row>
          <el-col :span="12">
            <el-form-item label="控制器名称" prop="controller">
              <el-input v-model="addForm.controller" placeholder="请输入菜单名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="动作名称" prop="action">
              <el-input v-model="addForm.action" placeholder="请输入菜单名称" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="权限控制" prop="type">
              <el-input v-model="addForm.type" placeholder="请输入菜单名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="层级代号" prop="code">
              <el-input v-model="addForm.code" placeholder="请输入菜单名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序号" prop="order">
              <el-input v-model="addForm.order" placeholder="请输入菜单名称" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSubmitForm">确 定</el-button>
        <el-button @click="closeForm">取 消</el-button>
      </div>
    </el-dialog>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes" :total="Total"></el-pagination>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="prev, pager, next, jumper"
        :total="Total"></el-pagination>
    </div>


    <!--更多选择!-->
    <el-dialog title="更多筛选" :visible.sync="dialogMoreVisible" width="35%" center=""  @closed="closeMoreForm()">
      <el-form ref="formMore" :model="formMore" label-width="90px" style="min-height: 200px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="菜单名称">
              <el-input class="select" clearable v-model.trim="formMore.label" placeholder="请输入菜单名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="权限控制">
              <el-input class="select" clearable v-model.trim="formMore.type" placeholder="请输入菜单级别"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="控制器名称">
              <el-input class="select" clearable v-model.trim="formMore.controller" placeholder="请输入菜单名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="动作名称">
              <el-input class="select" clearable v-model.trim="formMore.action" placeholder="请输入菜单级别"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="search1()">搜索</el-button>
      </div>
    </el-dialog>
  </div>
</template>
   
<script>
import {
   searchMenuList,
   deleteMenuList,
    updateMenuList,
    addMenuList,
    pidMenuList
 
} from "../../api/set.js";
export default {
  name: "menuManagement",
  data() {
    return {
      test:'0',
      list: [],
      loading: true,
      formMore: {

      },
      isPage: true,
      more: "",
      typeList: [],
      AddTitle: true,
      addForm: {
       
      },
      menuList: [
        ],
      rules: {
        label: [
          { required: true, message: '请输入菜单名', trigger: 'blur' },
        ],
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      dialogAddVisible: false,
      dialogMoreVisible: false,
      form: {},
      Total: 0,
      menuManagementUpdate:false,
      menuManagementAdd:false,
      menuManagementDelete:false,
    };
  },
  mounted() {
    this.menuManagementUpdate = this.$store.state.rolesname.includes('menuManagementUpdate');
    this.menuManagementAdd = this.$store.state.rolesname.includes('menuManagementAdd');
    this.menuManagementDelete = this.$store.state.rolesname.includes('menuManagementDelete');
    this.search();
    this.getMenuList()
  },

  methods: {
    search1(){
     
      this.currentPage=1
      this.search()
    },
    search() {
      let Params = {
        label:this.formMore.label,
        controller:this.formMore.controller,
        action:this.formMore.action,
        type:this.formMore.type,
        rows: this.pageSize,
        page: this.currentPage,
      };
      searchMenuList(Params)
        .then((res) => {
          if(res.data.status != "success"){
            this.$message.error(res.data.message);
            return;
          }
          if(res.status==200){
            this.tableData = res.data.data;

          this.Total = res.data.total;
          }else{
            this.$message.error('查询失败')
          }   
        })
        .catch(() => {
          this.$message.error("查询出错");
        });
      this.dialogMoreVisible=false
    },
    getMenuList(){
      pidMenuList()
        .then((res) => {
          if(res.data.status != "success"){
            this.$message.error(res.data.message);
            return;
          }
          if (res.status == 200) {
            this.menuList = res.data.data
            let obj= {
                "value": "00000000-0000-0000-0000-000000000000",
                "label": "Root"          
              }
              this.menuList.unshift(obj)
          } else {
            this.$message.error('数据获取失败')
          }
        })
        .catch(() => {
          this.$message.error("查询出错");
        });

    },
    //新增
    addClick() {
      this.AddTitle=true
      this.dialogAddVisible = true
    },
    //编辑
    editClick(row){
      console.log('row',row);
      this.AddTitle=false
      var list = JSON.parse(JSON.stringify(row))
     this.addForm=list
    this.dialogAddVisible = true

    },
    //新增取消按钮
    closeForm(){
      this.$refs['addRuleForm'].resetFields();
      this.addForm={}
      this.dialogAddVisible = false
    },
    //新增确认按钮
    addSubmitForm() {
      this.$refs['addRuleForm'].validate((valid) => {
          if (valid) {
          this.dialogAddVisible=false
      if(this.AddTitle){
        let Params = {
        id: this.addForm.id,
        label: this.addForm.label,
        pid: this.addForm.pid?this.addForm.pid:'00000000-0000-0000-0000-000000000000',
        code: this.addForm.code,
        controller:this.addForm.controller,
        action:this.addForm.action,
        type:this.addForm.type,
        code:this.addForm.code,
        order:this.addForm.order
      };
      addMenuList(Params)
        .then((res) => {
          if(res.data.status != "success"){
            this.$message.error(res.data.message);
            return;
          }
          if(res.status==200){
            this.$message.success('添加成功')
          this.search();
          this.getMenuList()
          }else{
            this.$message.error('添加失败')
          }
       
        })
        .catch(() => {
          this.$message.error("新增出错");
        });
      this.dialogAddVisible = false
      }else{
        let Params = {
        id: this.addForm.id,
        label: this.addForm.label,
        pid: this.addForm.pid,
        code: this.addForm.code,
        controller:this.addForm.controller,
        action:this.addForm.action,
        type:this.addForm.type,
        code:this.addForm.code,
        order:this.addForm.order
      };
      console.log('删除',Params);
      updateMenuList(Params)
        .then((res) => {
          if(res.data.status != "success"){
            this.$message.error(res.data.message);
            return;
          }
          if(res.status==200){
            this.$message.success('编辑成功')
          this.search();
          this.getMenuList()
          }else{
            this.$message.error('编辑失败')
          }
        })
        .catch(() => {
          this.$message.error("编辑出错");
        });
        this.dialogAddVisible = false
      }
     

          } else {
           this.$message.error('校验失败')
            return false;
          }
        });
     
     },
        //更改级联选择器
    handleChange(value) {
      if (value) {
        this.addForm.pid = value[value.length-1]
        console.log('value888',  this.addForm.pid);
      }
    },

    //分页
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //删除菜单
    changeStatus(row) {
      console.log('删除菜单',row);
      let Params = {
        id: row.id,
        status: 9,
      };
      deleteMenuList(Params)
        .then((res) => {
          if(res.data.status != "success"){
            this.$message.error(res.data.message);
            return;
          }
          if(res.status==200){
            this.$message.success('删除成功')
          this.search();
          this.getMenuList()
          }else{
            this.$message.error('删除失败')
          }
        
        })
        .catch(() => {
          this.$message.error("删除出错");
        });
     
    },

    //更多筛选
    moreSelect() {
      //更多选择
      this.dialogMoreVisible = true;
    },
    closeMoreForm(){
      this.formMore={}
      this.dialogMoreVisible=false
    }
  
  },
  computed: {
    // total() {
    //   return this.tableData.length;
    //   // return 9
    // },
  },
};
</script>
  
<style lang="less" scoped>
#join {

  // position: relative;
  .search {
    box-sizing: border-box;
    display: flex;
    padding: 24px;
    width: 100%;

    .el-input {
      width: 20%;
    }

    ::v-deep .el-input__inner {
      // width: 80% !important;
      // width: 300px;
      height: 45px;
      background-color: #fafafa;
      border: 0 !important;
    }

    .el-select {
      margin: 0 10px;
      width: 150px;
    }
  }

  .pagination {
    // position: absolute;
    // bottom: 40px;
    // right: 80px;
    margin: 20px 20px;
    // float: right;
    display: flex;
    justify-content: space-between;

    .el-pagination {
      padding-right: 50px;
    }
  }

  .sel-input-all {
    width: 70%;
  }

  .fj {
    // display: inline-flex;
    display: flex;
    align-items: center;
    background: #f5f7fa;
    justify-content: flex-start;
    padding: 10px;
    padding-right: 20px;
    margin-bottom: 10px;
  }

  .input {
    width: 75%;
  }

  .img {
    width: 100%;
  }

  .word {
    line-height: 18px;
    cursor: default;
  }

  .look {
    color: #fe964a;
  }

  .down {
    color: #2bc887;
    margin-left: 10px;
  }

  .dialog-footer {
    margin-bottom: 5%;
  }

  .select {
    // width: 300px;
    width: 10vw;
    margin-bottom: 1rem;
  }

  .btn {
    width: 100%;
    text-align: center;
  }
}
</style>
  